import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { getOrganizationDashboardRequestStatusesSummaryExport } from '@api/dashboardPO';

import { IOrganizationExportFileDTO } from '@interfaces/platform/dto/platformDashboardDTO';

import { ESnackbarTypes } from '@enums/common';

import { DASHBOARD_REQUEST_STATUSES_SUMMARY_ORGANIZATION_BY_STATUS_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export function useMutateOrganizationDashboardAssetStatusesExport() {
	const dispatch = useAppDispatch();

	const {
		mutate: exportOrganizationDashboardStatusesSummary,
		isLoading: isLoadingOrganizationDashboardStatusesSummary,
	} = useMutation<IOrganizationExportFileDTO>({
		mutationKey: [DASHBOARD_REQUEST_STATUSES_SUMMARY_ORGANIZATION_BY_STATUS_EXPORT],
		mutationFn: getOrganizationDashboardRequestStatusesSummaryExport,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportStartingSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return {
		exportOrganizationDashboardStatusesSummary,
		isLoadingOrganizationDashboardStatusesSummary,
	};
}
